import React from "react";
import WebRoutes from "./routes/WebRoutes";
/*StyleSheets*/
import "./styles/Style.css";
import "./styles/bootstrap.min.css";
import './styles/loader.css';
/*-----------*/
function App() {
  return (
    <div className="App">
      <WebRoutes />
    </div>
  );
}

export default App;
